import React, {useState, useEffect, useRef} from "react";
import Dashboard from "../../../core/Dashboard";
import { getActivePublishedRecords, getBranch, getMediaRecordCount, getMediaRecords, getMemberBranchActivityDetails, publishMediarecord, removeMediaRecords, removePublishedMediaRecords } from "../helper/api";
import { isAuthenticated } from '../../../auth';
import ManageBranchContent from "../../../components/modal/desktop/ManageBranchContent";
import Toast from "../../../lib/toast";
// import config from "../../../config";
import client from "../../../clients";
import { formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import ManageConfirmationModal from "../../../components/modal/ConfirmModal";
import { getMemberLoginRegistrationInfo } from "../../member/helper/api";
import FlatPicker from 'flatpickr';
import { useLocation } from "react-router-dom";
import LiveAdsPreview from "../../ads/Component/LiveAdsPreview";
import GymFilter from "../../../components/gym-filter";

let flatpickr;
let setTimer;

const KioskContent = (props) => {

  const { user, token } = isAuthenticated();
  const path = useLocation().pathname;
  const isEditOperationActive = useRef(false);
  const isUpdateToPublishRecord=useRef(false);
  const [isGlobalAdsPage, setGlobalAdsPage] = useState(false);
  const [branchId, setBranchId]= useState("");
  const [selectedBranchIDs,setSelectedBranchIDs]=useState([]);
  const [isButtonLock,setButtonLock] = useState(false);
  const [branch, setBranch] = useState();
  const [isOpenDeleteMediaRecordPopup,setOpenDeleteMediaRecordPopup] = useState(false);
  const [selectedMediaRecord,setSelectedMediaRecord] = useState("");
  const [isOpenRemoveLiveContentPopup,setOpenRemoveLiveContentPopup]=useState(false);
  const [currentHoveredElement, setCurrentHoveredElement] = useState(-1);
  const [isCreateContentModalOpen, setCreateContentModalOpen] = useState(false);
  const [publishedMediaRecords,setPublishedMediaRecords] = useState([]);  
  const [mediaRecords,setMediaRecords]=useState([]);
  const pageSize = {
    activeContent:20,
    savedContent:100
  };
  const [pageNo,setPageNo]=useState({
    activeContent:1,
    savedContent:1
  });
  const [pageCount,setPageCount]=useState({
    activeContent:1,
    savedContent:1
  });
  const [total,setTotal]=useState({
    activeContent:0,
    savedContent:0
  });
  const [selectedMediaRecordIDs,setSelectedMediaRecordIDs]=useState([]);
  const [isReloadContent,setReloadContent] = useState(false);
  const [currentAdsType, setCurrentAdsType] = useState("banner");
  const [bannerLiveContent, setBannerLiveContent] = useState([]);
  const [bannerAllContent, setBannerAllContent] = useState([]);
  const [isBannerAdsAssign, setBannerAdsAssign] = useState(false);
  const [currentHoveredBannerAds, setCurrentHoveredBannerAds] = useState(-1);
  const [branchMetaData,setBranchMetaData]=useState({kioskRegistrationCount:0,mobileRegisteredCount:0,memberCount:0});
  const [branchActivityDetail,setBranchActivityDetail] = useState({
    reportsCount:0,
    faceLoginCount:0
  });

  const [sortByDate,setSortByDate] = useState({
    startDate:"",
    endDate:""
  })

  const [isLiveAdsPreviewModalOpen, setLiveAdsPreviewModalOpen] = useState(false);
  const [adsType, setAdsType] = useState("horizontal");


  const onEndedVideo = data => e =>{
    const video = e.target;
    video.src = `${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}?t=${Date.now()}`;
    video.load();
    video.play();
  }


  const handleOpenLiveAd = (mediaRecord) =>{
    setSelectedMediaRecord(mediaRecord);
    setLiveAdsPreviewModalOpen(true);
  }

  const handleCloseLiveAd=()=>{
    setSelectedMediaRecord('')
    setLiveAdsPreviewModalOpen(false);
  }

  const handleBranchIDs=(branchIds)=>{
    setSelectedBranchIDs(branchIds)
  }

  const handleSortByDate = event => {
    flatpickr = FlatPicker("#date-range", {
      disableMobile: true,
      mode: 'range',
      onChange: (e) => {
        if(e.length>1) {
          setSortByDate({
            ...sortByDate,
            startDate:e[0],
            endDate:e[1]
          })
          //alert(JSON.stringify(e))
        }
      }
    })
    flatpickr.open();
  }

  const handleCancelSelectedMediaRecord = event =>{
    event.preventDefault()
    setSelectedMediaRecordIDs([]);
  }

  const handleSelectMediaRecord = (id) => event =>{
    let ids = [...selectedMediaRecordIDs];

    if(ids.indexOf(id) == -1) ids.push(id)
    else ids.splice(ids.indexOf(id),1)

    setSelectedMediaRecordIDs(ids);
    event.stopPropagation();
  }

  const GetMemberBranchActivityDetails=async ()=>{
    try{
      const params = {
        sortBy:"currentDate"
      }

      if(sortByDate.startDate && sortByDate.endDate && formatDateTime(new Date(sortByDate.startDate)) != formatDateTime(new Date(sortByDate.endDate))){
        params.sortBy="dateRange";
        params.startDate=sortByDate.startDate;
        params.endDate=sortByDate.endDate;
      }

      const response = await getMemberBranchActivityDetails(user._id,token,branch._id,params);
      if(response.error){

      }else{
        setBranchActivityDetail(response);
      }
    }catch(error){
      // do something
    }
  }

  const GetMemberLoginRegistrationInfo=async ()=>{
    try{
      const params = {
        sortBy:"branch",
        branchId:branch._id
      }

      const response = await getMemberLoginRegistrationInfo(user._id,token,params);

      if(response.error){

      }else{
        setBranchMetaData(response);
      }
    }catch(error){
      // do something
    }
  }

  const GetMediaRecordParams = () =>{
    const param={
      pageNo:pageNo.savedContent,
      pageSize:pageSize.savedContent,
      sortBy:currentAdsType == 'banner'?'banner':currentAdsType == 'tv'?'tv':'splashscreen',
      sortByMediaRecord:isGlobalAdsPage?"centralRecord":"branchRecord"
    };

    if(!isGlobalAdsPage){
      param.branchIDs=branch._id;
    }


    return param;
  }

  const PubLishMediaRecord = async event =>{
    try{
      event.preventDefault()
      setButtonLock(true)
      await startLoader()
      let payload = {
        mediaRecordIDs:selectedMediaRecordIDs
      }
      if(selectedMediaRecord){
        payload.mediaRecordIDs=[selectedMediaRecord._id];
      }
      payload.isAdminAds=isGlobalAdsPage;
      if(isGlobalAdsPage){
        payload.branchIDs = selectedBranchIDs;
      }

      if(currentAdsType == 'tv'){
        payload.isTvAds = true;
      }else{
        payload.isMainScreenBanner=currentAdsType == 'banner'?true:false
      }


      let response = await publishMediarecord(user._id,token,branchId?branchId:null,payload);

      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message:"Media record published successfully"
        })
        setSelectedMediaRecordIDs([])
        setReloadContent(!isReloadContent);
      }else{
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }

      if(isGlobalAdsPage){
        isUpdateToPublishRecord.current=false;
        isEditOperationActive.current=false;
        toggleCreateContentModal();
      }
    
      await stopLoader()
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:JSON.stringify(error)
      })
    }
    setButtonLock(false)
  }



  const GetPublishedMediaRecord = async () =>{
    try{
      const params={
        sortBy:currentAdsType == 'banner'?'banner':currentAdsType == 'tv'?'tv':'splashscreen',
        sortByMediaRecord:isGlobalAdsPage?"centrall-ads":"branch-ads"
      };
      let response = await getActivePublishedRecords(user._id,token,branch?branch._id:null,params);
      if(!response.error){
        let dataList = [];
        for(let data of response){
          dataList=[...dataList,...data.mediarecords];
        }
        setPublishedMediaRecords(dataList)
      }
    }catch(error){

    }
  }

  const handleRemoveLiveContentPopup = (mediaRecord="") =>{
    setSelectedMediaRecord(mediaRecord)
    setOpenRemoveLiveContentPopup(!isOpenRemoveLiveContentPopup)
  }

  const handleEditContent = (mediaRecord="") =>{
    setSelectedMediaRecord(mediaRecord)
    isEditOperationActive.current=true;
    setCreateContentModalOpen(!isCreateContentModalOpen)
    isUpdateToPublishRecord.current=true;
  }

  const handleDeleteContentPopup = (mediaRecord="") =>{
    setSelectedMediaRecord(mediaRecord)
    setOpenDeleteMediaRecordPopup(!isOpenDeleteMediaRecordPopup)
    isUpdateToPublishRecord.current=false;
    isEditOperationActive.current=false;
  }

  const handleRemoveLiveContentAction = async event =>{
    try{
      setButtonLock(true);
      await startLoader();
      let response = await removePublishedMediaRecords(user._id,token,branch?branch._id:null,{mediaRecordIDs:selectedMediaRecord._id});
      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message:response.message
        })
        setReloadContent(!isReloadContent);
      }else{
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }
      handleRemoveLiveContentPopup();
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:JSON.stringify(error)
      })
    }
    setButtonLock(false);
    await stopLoader()
  }

  const handleDeleteContentAction = async event =>{
    try{
      setButtonLock(true);
      await startLoader();
      let response = await removeMediaRecords(user._id,token,{mediaRecordIDs:selectedMediaRecord._id});
      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message:response.message
        })
        setReloadContent(!isReloadContent);
      }else{
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }
      handleDeleteContentPopup();
      isUpdateToPublishRecord.current=false;
      isEditOperationActive.current=false;
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:JSON.stringify(error)
      })
    }
    setButtonLock(false);
    await stopLoader()
  }

  const handleBranchSelect = event =>{
    setCreateContentModalOpen(!isCreateContentModalOpen)
    isUpdateToPublishRecord.current=true;
    isEditOperationActive.current=false;
  }

  const GetMediaRecordCount = async () =>{
    try{
      const params = GetMediaRecordParams();
      const response = await getMediaRecordCount(user._id,token,params);
      setPageCount({
        ...pageCount,
        savedContent:Math.ceil(response.COUNT / pageSize.savedContent)
      });
      setTotal({
        ...total,
        savedContent:response.COUNT
      });

    }catch(error){
      console.error(error)
    }
  }

  const GetMediaRecords = async (isReload) =>{
    try{
      const params = GetMediaRecordParams();
      const response = await getMediaRecords(user._id,token,params);
      console.log(response)
      if(response.error){
        // do something
      }else{
        if(isReload){
          setMediaRecords(response)
        } else {
          setMediaRecords([...mediaRecords,...response]);
        }
      }
    }catch(error){
      console.error(error)
    }
  }

  const getSelectedBranch = async() => {
    try {
      let response = await getBranch(user._id, token, branchId);
      if (response.error) {
        console.log('Get Branch');
      } else {
        console.log(response);
        setBranch(response);
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleHovered = (index) => {
      setCurrentHoveredElement(index)
  }

  const toggleCreateContentModal = (reload) => {
    setCreateContentModalOpen(!isCreateContentModalOpen)
    isEditOperationActive.current=false;
    isUpdateToPublishRecord.current=false;
    setSelectedMediaRecordIDs([]);
    setSelectedMediaRecord()
    if(reload){
     setReloadContent(!isReloadContent)
    }
  }

  const toggleBannerAdsAssign = (index) => {
    setBannerAdsAssign(!isBannerAdsAssign);
  }

  const handleHoverCurrentBannerAds = (index, type) => {
    setTimeout(() => {
      if(type && type == "live"){
        setCurrentHoveredBannerAds("live" + index);
      }else{
        setCurrentHoveredBannerAds(index);
      }
    }, 100);
  }

  const handleLeaveCurrentBannerAds = (index) => {
    setTimeout(() => {
      setCurrentHoveredBannerAds(-1);
    }, 100);
  }

  const handleCurrentAdsView = (type) => {
    if(currentAdsType != type){
      setPublishedMediaRecords([])
      setMediaRecords([])
      setSelectedMediaRecordIDs([])
    }
    setCurrentAdsType(type)
    isEditOperationActive.current=false;
    isUpdateToPublishRecord.current=false;
    setSelectedMediaRecord(null)
  }

  const handleSelectedGym = (selectedGym) => {
    setBranch(selectedGym);
  }

  const toggleGlobalAdsPreview = () => {
    setGlobalAdsPage(!isGlobalAdsPage)
  }

  useEffect(() => {
    if(branch != null){
      setBranchId(branch._id)
    }
  },[branch])

  useEffect(() => {
    const storedBranchId = localStorage.getItem("branchId");

    getSelectedBranch();
    setBranchId(storedBranchId);
  },[])

  useEffect(async ()=>{
    try{
      if(branch || isGlobalAdsPage){
        await startLoader();
        await GetMediaRecords(true); 
        await GetMediaRecordCount();
      }
      await stopLoader()
    }catch(error){
      console.log(error);
    }
  },[pageNo.savedContent,isReloadContent,branch,currentAdsType, isGlobalAdsPage])

  useEffect(async ()=>{
    try{
      if(branch || isGlobalAdsPage){
        await startLoader()
        await GetPublishedMediaRecord();
        await GetMemberLoginRegistrationInfo();
      }
      await stopLoader()
    }catch(error){
      console.error(error);
    }
  },[branch,isReloadContent,currentAdsType,isGlobalAdsPage]);

  useEffect(async ()=>{
    if(branch || isGlobalAdsPage){
      if(setTimer) clearTimeout(setTimer)
      setTimer = setTimeout(async ()=>{
        try{
          await startLoader()
          await GetMemberBranchActivityDetails()
          await stopLoader()
        }catch(error){
          await stopLoader()
        }
     },700);
    }
  },[branch,sortByDate,isGlobalAdsPage]);

  return(
    <Dashboard flag={-1} branch={branch} branchMetaData={branchMetaData} branchActivityDetail={branchActivityDetail} handleSortByDate={handleSortByDate} sortByDate={sortByDate}>
      <div className="header-bar d-flex space-between m-t-12" style={{padding:0}}>
        <div className='d-flex'>
          {/* <svg className='flex-item m-r-12 m-t-4' width="42" height="42" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0947 13.4375C11.5653 13.4375 11.0411 13.3332 10.552 13.1306C10.0629 12.9281 9.61847 12.6311 9.24413 12.2568C8.8698 11.8824 8.57286 11.438 8.37027 10.9489C8.16768 10.4599 8.06341 9.93564 8.06341 9.40625C8.06341 8.87686 8.16768 8.35265 8.37027 7.86356C8.57286 7.37447 8.8698 6.93007 9.24413 6.55573C9.61847 6.18139 10.0629 5.88445 10.552 5.68186C11.0411 5.47928 11.5653 5.375 12.0947 5.375C13.1638 5.375 14.1892 5.79972 14.9452 6.55573C15.7012 7.31174 16.1259 8.3371 16.1259 9.40625C16.1259 10.4754 15.7012 11.5008 14.9452 12.2568C14.1892 13.0128 13.1638 13.4375 12.0947 13.4375V13.4375ZM13.4384 15.9906C15.0662 15.6535 16.5112 14.7251 17.4945 13.3847C18.4778 12.0444 18.9295 10.3873 18.7625 8.73342C18.5954 7.07952 17.8214 5.54621 16.5899 4.42961C15.3585 3.31301 13.757 2.69235 12.0947 2.6875C10.4285 2.68583 8.8211 3.30332 7.58459 4.4201C6.34807 5.53688 5.57062 7.07327 5.40317 8.73102C5.23572 10.3888 5.69022 12.0496 6.67842 13.3911C7.66663 14.7326 9.11804 15.6591 10.7509 15.9906V27.0094C9.12316 27.3466 7.67809 28.275 6.69481 29.6153C5.71153 30.9556 5.25979 32.6127 5.42685 34.2666C5.59391 35.9205 6.36792 37.4538 7.59937 38.5704C8.83082 39.687 10.4324 40.3077 12.0947 40.3125C13.7608 40.3142 15.3682 39.6967 16.6047 38.5799C17.8412 37.4631 18.6187 35.9267 18.7861 34.269C18.9536 32.6112 18.4991 30.9504 17.5109 29.6089C16.5227 28.2674 15.0713 27.3409 13.4384 27.0094V24.1875H25.5322C26.4145 24.1875 27.2882 24.0137 28.1033 23.6761C28.9185 23.3384 29.6591 22.8435 30.283 22.2196C30.9069 21.5957 31.4018 20.8551 31.7395 20.0399C32.0771 19.2248 32.2509 18.3511 32.2509 17.4688V15.9906C33.8787 15.6535 35.3237 14.7251 36.307 13.3847C37.2903 12.0444 37.742 10.3873 37.575 8.73342C37.4079 7.07952 36.6339 5.54621 35.4024 4.42961C34.171 3.31301 32.5695 2.69235 30.9072 2.6875C29.241 2.68583 27.6336 3.30332 26.3971 4.4201C25.1606 5.53688 24.3831 7.07327 24.2157 8.73102C24.0482 10.3888 24.5027 12.0496 25.4909 13.3911C26.4791 14.7326 27.9305 15.6591 29.5634 15.9906V17.4688C29.5634 18.5379 29.1387 19.5633 28.3827 20.3193C27.6267 21.0753 26.6013 21.5 25.5322 21.5H13.4384V15.9906ZM30.9072 13.4375C30.3778 13.4375 29.8536 13.3332 29.3645 13.1306C28.8754 12.9281 28.431 12.6311 28.0566 12.2568C27.6823 11.8824 27.3854 11.438 27.1828 10.9489C26.9802 10.4599 26.8759 9.93564 26.8759 9.40625C26.8759 8.87686 26.9802 8.35265 27.1828 7.86356C27.3854 7.37447 27.6823 6.93007 28.0566 6.55573C28.431 6.18139 28.8754 5.88445 29.3645 5.68186C29.8536 5.47928 30.3778 5.375 30.9072 5.375C31.9763 5.375 33.0017 5.79972 33.7577 6.55573C34.5137 7.31174 34.9384 8.3371 34.9384 9.40625C34.9384 10.4754 34.5137 11.5008 33.7577 12.2568C33.0017 13.0128 31.9763 13.4375 30.9072 13.4375V13.4375ZM16.1259 33.5938C16.1259 34.6629 15.7012 35.6883 14.9452 36.4443C14.1892 37.2003 13.1638 37.625 12.0947 37.625C11.0255 37.625 10.0001 37.2003 9.24413 36.4443C8.48813 35.6883 8.06341 34.6629 8.06341 33.5938C8.06341 32.5246 8.48813 31.4992 9.24413 30.7432C10.0001 29.9872 11.0255 29.5625 12.0947 29.5625C13.1638 29.5625 14.1892 29.9872 14.9452 30.7432C15.7012 31.4992 16.1259 32.5246 16.1259 33.5938V33.5938Z" fill="var(--darkBlue)" />
          </svg> */}
          <svg className='flex-item m-r-12' width="55" height="55" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.02148 9.22877L12.0066 14.5555L12.0601 14.6518C12.3571 15.1696 12.8116 15.5727 13.3536 15.7988C13.8955 16.0249 14.4949 16.0616 15.0591 15.9031C15.6233 15.7445 16.1211 15.3997 16.4758 14.9217C16.8304 14.4437 17.0222 13.8591 17.0215 13.258C17.0232 12.7765 16.9004 12.3032 16.6658 11.8864L16.6364 11.8371L11.4501 2.61027V2.60761C10.7871 1.42053 10.102 1 9.02148 1C8.56257 0.999637 8.11137 1.12116 7.71164 1.35277C7.3119 1.58439 6.97721 1.91823 6.74002 2.32193L6.66793 2.45101C6.46719 2.83562 6.35496 3.27567 6.35496 3.74012C6.35384 4.18108 6.45664 4.61577 6.65455 5.00704L6.67311 5.04297L6.74822 5.17205L9.02148 9.22877ZM9.02148 9.22877L6.03119 14.5666M6.03119 14.5666C6.23711 14.1762 6.35496 13.7309 6.35496 13.258C6.35502 12.6641 6.16691 12.0862 5.81974 11.6114C5.47257 11.1366 4.98469 10.7905 4.42955 10.6253C3.87442 10.4601 3.28208 10.4846 2.7417 10.6953C2.20132 10.9059 1.74215 11.2912 1.43331 11.7932M6.03119 14.5666L5.98327 14.6544C5.74736 15.0641 5.4116 15.4036 5.00911 15.6393C4.60661 15.875 4.15127 15.9988 3.688 15.9985C3.33775 15.9987 2.99089 15.9279 2.66727 15.7903C2.34365 15.6526 2.04961 15.4507 1.80196 15.1962C1.55431 14.9417 1.35791 14.6395 1.22399 14.3069C1.09007 13.9743 1.02126 13.6179 1.02148 13.258C1.02148 12.7966 1.13113 12.3619 1.32928 11.9804L1.43072 11.7985L1.43331 11.7932M1.43331 11.7932L6.66793 2.45057" stroke="var(--extraDarkBlue)" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div className='flex-item'>
            <p className="fs-26 font-weight-600 color-extra-dark-blue flex-item" style={{lineHeight:"26px"}}>Advertisements</p>
            <p className="fs-12 cursor-pointer m-t-2">Manage your ads here</p>
          </div>
          {/* <div className='flex-item'>
            <p className="dashboard-type-heading flex-item">{isGlobalAdsPage?"Ads":"Branch"}</p>
            { !isGlobalAdsPage && <p className='dashboard-route-txt color-green'>{`Branch > ${(branch && branch.name) ? branch.name : ""}`}</p>}
          </div> */}
        </div>
        <div className="d-flex">
          {/* member-button-global-inactive */}

          <div onClick={()=>toggleCreateContentModal()} className="more-global-action-btn flex-item d-flex" style={{height:"54px", marginLeft:"12px", marginRight:"12px"}}>
            <svg className="flex-item margin-auto svg-fill" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C8.42758 0 8.77419 0.346618 8.77419 0.774194V7.22581H15.2258C15.6534 7.22581 16 7.57242 16 8C16 8.42758 15.6534 8.77419 15.2258 8.77419H8.77419V15.2258C8.77419 15.6534 8.42758 16 8 16C7.57242 16 7.22581 15.6534 7.22581 15.2258V8.77419H0.774194C0.346618 8.77419 0 8.42758 0 8C0 7.57242 0.346618 7.22581 0.774194 7.22581H7.22581V0.774194C7.22581 0.346618 7.57242 0 8 0Z" fill="var(--darkBlue)"/>
            </svg>
          </div>
          
          {
            !isGlobalAdsPage && (
              <GymFilter getSelectedGym={handleSelectedGym} />
            )
          }

         {user.role == 0 && <div onClick={()=>toggleGlobalAdsPreview()} className="more-global-action-btn flex-item d-flex" style={{height:"54px", marginLeft:!isGlobalAdsPage && "12px"}}>
            <svg className="flex-item svg-stroke" width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.75 18.75C10.9319 18.75 12.1022 18.5172 13.1942 18.0649C14.2861 17.6126 15.2782 16.9497 16.114 16.114C16.9497 15.2782 17.6126 14.2861 18.0649 13.1942C18.5172 12.1022 18.75 10.9319 18.75 9.75C18.75 8.5681 18.5172 7.39778 18.0649 6.30585C17.6126 5.21392 16.9497 4.22177 16.114 3.38604C15.2782 2.55031 14.2861 1.88738 13.1942 1.43508C12.1022 0.982792 10.9319 0.75 9.75 0.75M9.75 18.75C8.5681 18.75 7.39778 18.5172 6.30585 18.0649C5.21392 17.6126 4.22177 16.9497 3.38604 16.114C2.55031 15.2782 1.88738 14.2861 1.43508 13.1942C0.982792 12.1022 0.75 10.9319 0.75 9.75C0.75 8.5681 0.982792 7.39778 1.43508 6.30585C1.88738 5.21392 2.55031 4.22177 3.38604 3.38604C4.22177 2.55031 5.21392 1.88738 6.30585 1.43508C7.39778 0.982792 8.5681 0.75 9.75 0.75M9.75 18.75C12.511 18.75 13.691 13.587 13.691 9.75C13.691 5.913 12.511 0.75 9.75 0.75M9.75 18.75C6.989 18.75 5.809 13.587 5.809 9.75C5.809 5.913 6.989 0.75 9.75 0.75M1.25 6.75H18.25M1.25 12.75H18.25" stroke="var(--darkBlue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {
              isGlobalAdsPage && (
                <div className="d-flex">
                  <p className="text-highlight flex-item fs-16 font-weight-700 color-dark-blue m-r-12 m-l-6">Global Ads</p>
                  <svg className="flex-item m-l-12" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 13.75L13.75 0.75M13.75 13.75L0.75 0.75" stroke="#E33A34" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              )
            }
          </div>}

          {/* <div onClick={()=>toggleCreateContentModal()} className="global-round-btn d-flex flex-item m-r-12">
            <svg className="flex-item margin-auto rect-fill-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="7.4668" width="1.06667" height="16" rx="0.533333" fill="#6D6D6D"/>
              <rect y="8.5332" width="1.06667" height="16" rx="0.533333" transform="rotate(-90 0 8.5332)" fill="#6D6D6D"/>
            </svg>
          </div> */}
        
          {/* <div className="d-flex m-r-12" style={{backgroundColor:"#ffffff", borderRadius:"20px"}}>

         
            <div onClick={() => handleCurrentAdsView("banner")} className={`${currentAdsType == "banner" ? "global-blue-button-controller-active" : ""} member-button-global btn-center d-flex`} style={{boxShadow: currentAdsType == "banner" ? "" : "none"}}>
              <p className="flex-item">Banner Content</p>
            </div>
            <div onClick={() => handleCurrentAdsView("splash")} className={`${currentAdsType == "splash" ? "global-blue-button-controller-active" : ""} member-button-global btn-center d-flex`} style={{boxShadow: currentAdsType == "splash" ? "" : "none"}}>
              <p className="flex-item">Splash Content</p>
            </div>
          
            <div onClick={() => handleCurrentAdsView("tv")} className={`${currentAdsType == "tv" ? "global-blue-button-controller-active" : ""} member-button-global btn-center d-flex`} style={{boxShadow: currentAdsType == "tv" ? "" : "none"}}>
              <p className="flex-item">Tv Ads</p>
            </div>
          </div>
          
          {/* <div className='global-round-btn d-flex flex-item'>
            <svg className='flex-item fill-svg' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 4H12.95C12.7 2.85 11.7 2 10.5 2C9.3 2 8.3 2.85 8.05 4H1V5H8.05C8.3 6.15 9.3 7 10.5 7C11.7 7 12.7 6.15 12.95 5H15V4ZM10.5 6C9.65 6 9 5.35 9 4.5C9 3.65 9.65 3 10.5 3C11.35 3 12 3.65 12 4.5C12 5.35 11.35 6 10.5 6ZM1 12H3.05C3.3 13.15 4.3 14 5.5 14C6.7 14 7.7 13.15 7.95 12H15V11H7.95C7.7 9.85 6.7 9 5.5 9C4.3 9 3.3 9.85 3.05 11H1V12ZM5.5 10C6.35 10 7 10.65 7 11.5C7 12.35 6.35 13 5.5 13C4.65 13 4 12.35 4 11.5C4 10.65 4.65 10 5.5 10Z" fill="#6D6D6D" />
            </svg>
          </div> */}
        </div>
      </div>
      <div className='dashboard-data-saperator m-t-12'></div>

      <div className="d-flex w-full m-b-30">

        <div onClick={() => handleCurrentAdsView("banner")} className="more-global-action-btn flex-item d-flex" style={{background:currentAdsType == "banner" && "#E33A34", height:"40px"}}>
          <p className="flex-item text-highlight" style={{color:currentAdsType == "banner" && "#ffffff"}}>Banner Content</p>
        </div>

        <div onClick={() => handleCurrentAdsView("splash")} className="more-global-action-btn flex-item d-flex" style={{background:currentAdsType == "splash" && "#E33A34", height:"40px", marginLeft:"12px"}}>
          <p className="flex-item text-highlight" style={{color:currentAdsType == "splash" && "#ffffff"}}>Splash Content</p>
        </div>

        <div onClick={() => handleCurrentAdsView("tv")} className="more-global-action-btn flex-item d-flex" style={{background:currentAdsType == "tv" && "#E33A34", height:"40px", marginLeft:"12px"}}>
          <p className="flex-item text-highlight" style={{color:currentAdsType == "tv" && "#ffffff"}}>TV Content</p>
        </div>
      </div>

      {
        currentAdsType == 'splash' && (
          <div className="branch-content-container">
            <div className="d-flex space-between">
              <p className="flex-item font-weight-700 color-dark-blue fs-16">Kiosk Live Contents</p>
              <div className="flex-item content-lining" />
              <p className="flex-item color-red font-weight-700 fs-16">{publishedMediaRecords.length}/{client.config.maxLiveImageContent}</p>
            </div>
            {/* {console.log(publishedMediaRecords)} */}
            <div className="d-flex content-horizontal-scroll-container m-t-20">
              {
                publishedMediaRecords.map((data, index) => {
                  return(
                    <div onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHovered(index)} onMouseLeave={()=>handleHovered(-1)} className="flex-item m-r-28 content-item cursor-pointer">
                      {
                        data.urlType == "hls"?(
                          <svg className="flex-item" style={{marginTop:30}} width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 12V10H18V12H16ZM16 14H14V12H16V14ZM16 16V14H18V16H16ZM11.194 8L9.194 6H4.615C4.43567 6 4.28834 6.05767 4.173 6.173C4.05767 6.28833 4 6.436 4 6.616V17.385C4 17.5643 4.05767 17.7117 4.173 17.827C4.28834 17.9423 4.436 18 4.616 18H14V16H16V18H19.385C19.5643 18 19.7117 17.9423 19.827 17.827C19.9423 17.7117 20 17.5643 20 17.385V8.615C20 8.43567 19.9423 8.28833 19.827 8.173C19.7117 8.05767 19.5643 8 19.385 8H16V10H14V8H11.194ZM4.615 19C4.155 19 3.77067 18.846 3.462 18.538C3.15334 18.23 2.99934 17.8453 3 17.384V6.616C3 6.15533 3.15434 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H9.596L11.596 7H19.385C19.845 7 20.2293 7.15433 20.538 7.463C20.8467 7.77167 21.0007 8.156 21 8.616V17.385C21 17.845 20.846 18.2293 20.538 18.538C20.23 18.8467 19.8457 19.0007 19.385 19H4.615Z" fill="black"/>
                          </svg>
                        ): data.urlType == "mp4" ? (
                          <video onEnded={onEndedVideo(data)} width="112px" height="182px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} />
                        ):(
                          <img loading="lazy" className="flex-item " src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} />
                        )
                      }
                      {
                        currentHoveredElement == index && (
                          <div className="w-full h-full content-hover-elem">
                            <div className="w-full p-l-8 p-r-8" style={{alignItems:"flex-end"}}>
                              <p style={{color:"#ffffff", marginTop:"55px", lineHeight:"18px", fontSize:"13px",visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Fuel Your Gains with MuscleBlaze – Unleash Your Inner Beast!"}</p>
                              <div className="d-flex space-between m-t-8">
                              {
                                isGlobalAdsPage && (
                                  <div onClick={e=>{handleEditContent(data); e.stopPropagation()}} className="content-action-button cursor-pointer d-flex flex-item m-r-8">
                                     <svg className="flex-item margin-auto" width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.1819 4.81833C18.6578 4.29436 17.9471 4 17.206 4C16.4649 4 15.7541 4.29436 15.23 4.81833L5.34722 14.7023C5.05902 14.9903 4.86017 15.3555 4.77459 15.7538L4.01279 19.3083C3.9927 19.4017 3.99632 19.4986 4.02333 19.5901C4.05034 19.6817 4.09986 19.7651 4.16739 19.8326C4.23491 19.9001 4.31828 19.9497 4.40987 19.9767C4.50147 20.0037 4.59837 20.0073 4.69172 19.9872L8.24641 19.2255C8.64477 19.1399 9.00993 18.941 9.29795 18.6528L19.1819 8.76942C19.7057 8.24539 20 7.5348 20 6.79387C20 6.05295 19.7057 5.34236 19.1819 4.81833ZM16.0387 5.62638C16.3512 5.33088 16.7666 5.16892 17.1967 5.17495C17.6267 5.18097 18.0375 5.35451 18.3415 5.65865C18.6456 5.96279 18.8191 6.37354 18.825 6.80357C18.8309 7.2336 18.6688 7.64897 18.3732 7.96137L17.8589 8.47569L15.5238 6.14126L16.0387 5.62638ZM14.7151 6.94931L17.0502 9.2843L8.49043 17.8454C8.35798 17.9778 8.19008 18.069 8.00695 18.1082L5.31465 18.6854L5.89186 15.9938C5.93105 15.8107 6.02235 15.6428 6.15474 15.5104L14.7151 6.94931Z" fill="black"/>
                                     </svg>
                                  </div>
                                )
                              }
                                <div onClick={e=>{ handleRemoveLiveContentPopup(data); e.stopPropagation()}} className="content-action-button cursor-pointer flex-item d-flex">
                                  <svg className="flex-item margin-auto" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.12598 10.8331C3.88332 10.8331 3.67676 10.7479 3.50632 10.5774C3.33587 10.407 3.25065 10.2006 3.25065 9.95831V3.24977H2.70898V2.7081H4.87565V2.29102H8.12565V2.7081H10.2923V3.24977H9.75065V9.95831C9.75065 10.2075 9.66723 10.4157 9.5004 10.5828C9.33357 10.75 9.12521 10.8335 8.87532 10.8331H4.12598ZM9.20898 3.24977H3.79232V9.95831C3.79232 10.0554 3.82355 10.1353 3.88603 10.1977C3.9485 10.2602 4.02848 10.2914 4.12598 10.2914H8.87586C8.95892 10.2914 9.03529 10.2568 9.10498 10.1874C9.17468 10.1181 9.20935 10.0415 9.20898 9.95777V3.24977ZM5.31332 9.2081H5.85498V4.3331H5.31332V9.2081ZM7.14632 9.2081H7.68798V4.3331H7.14632V9.2081Z" fill="#FF0000"/>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      </div>
                    )
                  }
                )
              }
            </div>
            <div className="d-flex space-between m-t-30">
              <p className="flex-item font-weight-700 color-dark-blue m-r-12 fs-16">All Contents</p>
              <div className="flex-item content-lining-2" />
              <p className="flex-item font-weight-700 color-red fs-16">{total.savedContent}</p>
            </div>
            <div className="d-flex-wrap w-full m-t-20">
              {
                mediaRecords.map((data, index) => {
                  return(
                    <div onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHovered("all"+index)} onMouseLeave={()=>handleHovered("all-1")} className="flex-item m-r-28 m-b-28 content-item cursor-pointer">
                      {
                        publishedMediaRecords.findIndex(d=>d._id == data._id) == -1 && (
                          <input onClick={handleSelectMediaRecord(data._id)} checked={selectedMediaRecordIDs.indexOf(data._id)!=-1} style={{position:"absolute", zIndex: 3, top: 0, left: 0, margin: "12px 0 0 12px", width: "16px", height:"16px"}} type="checkbox" />
                        )
                      }
                      {
                        data.urlType == "hls"?(
                          <svg className="flex-item" style={{marginTop:30}} width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 12V10H18V12H16ZM16 14H14V12H16V14ZM16 16V14H18V16H16ZM11.194 8L9.194 6H4.615C4.43567 6 4.28834 6.05767 4.173 6.173C4.05767 6.28833 4 6.436 4 6.616V17.385C4 17.5643 4.05767 17.7117 4.173 17.827C4.28834 17.9423 4.436 18 4.616 18H14V16H16V18H19.385C19.5643 18 19.7117 17.9423 19.827 17.827C19.9423 17.7117 20 17.5643 20 17.385V8.615C20 8.43567 19.9423 8.28833 19.827 8.173C19.7117 8.05767 19.5643 8 19.385 8H16V10H14V8H11.194ZM4.615 19C4.155 19 3.77067 18.846 3.462 18.538C3.15334 18.23 2.99934 17.8453 3 17.384V6.616C3 6.15533 3.15434 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H9.596L11.596 7H19.385C19.845 7 20.2293 7.15433 20.538 7.463C20.8467 7.77167 21.0007 8.156 21 8.616V17.385C21 17.845 20.846 18.2293 20.538 18.538C20.23 18.8467 19.8457 19.0007 19.385 19H4.615Z" fill="black"/>
                          </svg>
                        ): data.urlType == "mp4" ? (
                          <video onEnded={onEndedVideo(data)} width="112px" height="182px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} />
                        ):(
                          <img loading="lazy" className="flex-item " src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} />
                        )
                      }
                      {
                        currentHoveredElement == "all"+index && (
                          <div className="w-full h-full content-hover-elem">
                            <div className="w-full p-l-8 p-r-8" style={{alignItems:"flex-end"}}>
                              <p style={{color:"#ffffff", marginTop:"55px", lineHeight:"18px", fontSize:"13px", visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Fuel Your Gains with MuscleBlaze – Unleash Your Inner Beast!"}</p>
                              <div className="d-flex space-between m-t-8">
                                <div onClick={e=>{handleDeleteContentPopup(data);e.stopPropagation()}} className="content-action-button cursor-pointer d-flex">
                                  <svg className="flex-item margin-auto" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.12598 10.8331C3.88332 10.8331 3.67676 10.7479 3.50632 10.5774C3.33587 10.407 3.25065 10.2006 3.25065 9.95831V3.24977H2.70898V2.7081H4.87565V2.29102H8.12565V2.7081H10.2923V3.24977H9.75065V9.95831C9.75065 10.2075 9.66723 10.4157 9.5004 10.5828C9.33357 10.75 9.12521 10.8335 8.87532 10.8331H4.12598ZM9.20898 3.24977H3.79232V9.95831C3.79232 10.0554 3.82355 10.1353 3.88603 10.1977C3.9485 10.2602 4.02848 10.2914 4.12598 10.2914H8.87586C8.95892 10.2914 9.03529 10.2568 9.10498 10.1874C9.17468 10.1181 9.20935 10.0415 9.20898 9.95777V3.24977ZM5.31332 9.2081H5.85498V4.3331H5.31332V9.2081ZM7.14632 9.2081H7.68798V4.3331H7.14632V9.2081Z" fill="#FF0000"/>
                                  </svg>
                                </div>
                              </div>
                              <div className="d-flex flex-item">
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              )}
            </div>
          </div>
        )
      }

            
      {
        currentAdsType == 'banner' && (
          <div className="branch-content-container" >
            <div className="d-flex m-t-2">
              <p className="flex-item font-weight-700 color-dark-blue m-r-12 fs-16">Banner Live Contents</p>
              <div className="number-highlighter d-flex">
                <p className="flex-item font-weight-600 fs-16" style={{color:"#107CB1"}}>{publishedMediaRecords.length} {!isGlobalAdsPage&&<>/ {client.config.maxBannerLiveContent}</>}</p>
              </div>
            </div>
            <div className="d-flex m-t-16 w-full">
              {
                publishedMediaRecords.map((data,index) => {
                  return(
                    <div onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHoverCurrentBannerAds(index,"live")} onMouseLeave={()=>handleLeaveCurrentBannerAds(index, "live")} className="banner-content-container flex-item m-r-20 m-b-20 cursor-pointer">
                      {/* <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> */}
                      {
                        data.urlType == "mp4" ? (
                          <video onEnded={onEndedVideo(data)} width="100%" height="100px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} controls />
                        ):(
                          <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> 
                        )
                      }
                      {
                        currentHoveredBannerAds == "live" + index && (
                          <div className="banner-content-container fadeIn-2"/>  
                        )
                      }
                      
                      <div className="inner-controller d-flex">
                        {
                          currentHoveredBannerAds == "live" + index && (
                            <div className="d-flex fadeIn-2">
                              {
                                isGlobalAdsPage && (
                                  <div onClick={e=>{handleEditContent(data); e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item m-r-8">
                                    <svg className="flex-item" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M19.1819 4.81833C18.6578 4.29436 17.9471 4 17.206 4C16.4649 4 15.7541 4.29436 15.23 4.81833L5.34722 14.7023C5.05902 14.9903 4.86017 15.3555 4.77459 15.7538L4.01279 19.3083C3.9927 19.4017 3.99632 19.4986 4.02333 19.5901C4.05034 19.6817 4.09986 19.7651 4.16739 19.8326C4.23491 19.9001 4.31828 19.9497 4.40987 19.9767C4.50147 20.0037 4.59837 20.0073 4.69172 19.9872L8.24641 19.2255C8.64477 19.1399 9.00993 18.941 9.29795 18.6528L19.1819 8.76942C19.7057 8.24539 20 7.5348 20 6.79387C20 6.05295 19.7057 5.34236 19.1819 4.81833ZM16.0387 5.62638C16.3512 5.33088 16.7666 5.16892 17.1967 5.17495C17.6267 5.18097 18.0375 5.35451 18.3415 5.65865C18.6456 5.96279 18.8191 6.37354 18.825 6.80357C18.8309 7.2336 18.6688 7.64897 18.3732 7.96137L17.8589 8.47569L15.5238 6.14126L16.0387 5.62638ZM14.7151 6.94931L17.0502 9.2843L8.49043 17.8454C8.35798 17.9778 8.19008 18.069 8.00695 18.1082L5.31465 18.6854L5.89186 15.9938C5.93105 15.8107 6.02235 15.6428 6.15474 15.5104L14.7151 6.94931Z" fill="black"/>
                                    </svg>
                                  </div>
                                )
                              }
                              <div onClick={e=>{handleRemoveLiveContentPopup(data); e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item">
                                <svg className="flex-item" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.44202 11.6665C4.18068 11.6665 3.95824 11.5747 3.77468 11.3911C3.59113 11.2076 3.49935 10.9853 3.49935 10.7244V3.49979H2.91602V2.91645H5.24935V2.46729H8.74935V2.91645H11.0827V3.49979H10.4993V10.7244C10.4993 10.9927 10.4095 11.2169 10.2298 11.397C10.0502 11.577 9.82579 11.6668 9.55668 11.6665H4.44202ZM9.91602 3.49979H4.08268V10.7244C4.08268 10.829 4.11632 10.9149 4.1836 10.9822C4.25088 11.0495 4.33702 11.0831 4.44202 11.0831H9.55727C9.64671 11.0831 9.72896 11.0458 9.80402 10.9711C9.87907 10.8965 9.9164 10.814 9.91602 10.7238V3.49979ZM5.72068 9.91645H6.30402V4.66645H5.72068V9.91645ZM7.69468 9.91645H8.27802V4.66645H7.69468V9.91645Z" fill="#FF0000"/>
                                </svg>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    
                      {
                        currentHoveredBannerAds == "live" + index && (
                          <p className="flex-item color-white title fs-16 font-weight-300 fadeIn-2" style={{lineHeight:"22px",visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Content Name long, Content Name long"}</p>
                        )
                      }
                    </div> 
                  )
                })
              }
            </div>

            <div className="d-flex space-between m-t-30">
              <div className="d-flex">
                <p className="flex-item font-weight-700 color-dark-blue m-r-12 fs-16">All Contents</p>
                <div className="number-highlighter d-flex">
                  <p className="flex-item font-weight-600 fs-16" style={{color:"#107CB1"}}>{total.savedContent}</p>
                </div>
              </div>
              <div className="d-flex">
                <p className="flex-item font-weight-400 m-r-12 fs-16" style={{color:"#282828"}}>Publish Mode</p>
                <div onClick={() => toggleBannerAdsAssign()} className='flex-item d-flex active-inactive-button' style={{ background: !isBannerAdsAssign ? "rgba(255, 0, 85, 0.347)" : "" }}>
                  <div className='active-inactive-ball flex-item' style={{ background: !isBannerAdsAssign ? "rgb(201, 0, 57)" : "", margin: !isBannerAdsAssign ? "0 0 0 0" : "" }} />
                </div>
              </div>
            </div>
            <div className="d-flex-wrap m-t-16 w-full">
              {
                mediaRecords.map((data, index) => {
                  return(
                    <div onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHoverCurrentBannerAds(index)} onMouseLeave={()=>handleLeaveCurrentBannerAds(index)} className="banner-content-container flex-item  m-r-20 m-b-20 cursor-pointer">
                       {
                        data.urlType == "mp4" ? (
                          <video onEnded={onEndedVideo(data)} width="100%" height="100px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} controls />
                        ):(
                          <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> 
                        )
                      }
                      {/* <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> */}
                      {
                        currentHoveredBannerAds == index && (
                          <div className="banner-content-container fadeIn-2"/>  
                        )
                      }
                      {
                        isBannerAdsAssign ? (
                          (publishedMediaRecords.findIndex(d=>d._id == data._id) == -1) && ( <div className="inner-controller d-flex">
                            <input onClick={handleSelectMediaRecord(data._id)} checked={selectedMediaRecordIDs.indexOf(data._id)!=-1} className="m-t-4 m-l-4" type="checkbox" style={{width:"18px", height:"18px"}} />
                          </div>)
                        ) : (
                          <div className="inner-controller d-flex">

                            {
                              currentHoveredBannerAds == index && (
                                <div className="d-flex fadeIn-2">
                                  <div onClick={e=>{handleDeleteContentPopup(data);e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item">
                                    <svg className="flex-item" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.44202 11.6665C4.18068 11.6665 3.95824 11.5747 3.77468 11.3911C3.59113 11.2076 3.49935 10.9853 3.49935 10.7244V3.49979H2.91602V2.91645H5.24935V2.46729H8.74935V2.91645H11.0827V3.49979H10.4993V10.7244C10.4993 10.9927 10.4095 11.2169 10.2298 11.397C10.0502 11.577 9.82579 11.6668 9.55668 11.6665H4.44202ZM9.91602 3.49979H4.08268V10.7244C4.08268 10.829 4.11632 10.9149 4.1836 10.9822C4.25088 11.0495 4.33702 11.0831 4.44202 11.0831H9.55727C9.64671 11.0831 9.72896 11.0458 9.80402 10.9711C9.87907 10.8965 9.9164 10.814 9.91602 10.7238V3.49979ZM5.72068 9.91645H6.30402V4.66645H5.72068V9.91645ZM7.69468 9.91645H8.27802V4.66645H7.69468V9.91645Z" fill="#FF0000"/>
                                    </svg>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        )
                      }
                      {
                        currentHoveredBannerAds == index && (
                          <p className="flex-item color-white title fs-16 font-weight-300 fadeIn-2" style={{lineHeight:"22px",visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Content Name long, Content Name long"}</p>
                        )
                      }
                    </div> 
                  )
                })
              }
            </div>
          </div>
        )
      }


      {
        currentAdsType == 'tv' && (
          <div className="branch-content-container" >
          <div className="d-flex m-t-2">
            <p className="flex-item font-weight-700 color-dark-blue m-r-12 fs-16">Tv Live Ads</p>
            <div className="number-highlighter d-flex">
              <p className="flex-item font-weight-600 fs-16" style={{color:"#107CB1"}}>{publishedMediaRecords.length} {!isGlobalAdsPage&&<>/ {client.config.maxBannerLiveContent}</>}</p>
            </div>
          </div>
          <div className="d-flex m-t-16 w-full">
            {
              publishedMediaRecords.map((data,index) => {
                return(
                  <div style={{backgroundColor:data.urlType=="hls" && '#e0e0e0'}} onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHoverCurrentBannerAds(index,"live")} onMouseLeave={()=>handleLeaveCurrentBannerAds(index, "live")} className="banner-content-container flex-item m-r-20 m-b-20 cursor-pointer">
                   
                   {
                      data.urlType == "hls"?(
                       <div className="d-flex flex-item w-full" style={{justifyContent:'center'}}>
                         <svg className="flex-item"  width="110" height="110" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 12V10H18V12H16ZM16 14H14V12H16V14ZM16 16V14H18V16H16ZM11.194 8L9.194 6H4.615C4.43567 6 4.28834 6.05767 4.173 6.173C4.05767 6.28833 4 6.436 4 6.616V17.385C4 17.5643 4.05767 17.7117 4.173 17.827C4.28834 17.9423 4.436 18 4.616 18H14V16H16V18H19.385C19.5643 18 19.7117 17.9423 19.827 17.827C19.9423 17.7117 20 17.5643 20 17.385V8.615C20 8.43567 19.9423 8.28833 19.827 8.173C19.7117 8.05767 19.5643 8 19.385 8H16V10H14V8H11.194ZM4.615 19C4.155 19 3.77067 18.846 3.462 18.538C3.15334 18.23 2.99934 17.8453 3 17.384V6.616C3 6.15533 3.15434 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H9.596L11.596 7H19.385C19.845 7 20.2293 7.15433 20.538 7.463C20.8467 7.77167 21.0007 8.156 21 8.616V17.385C21 17.845 20.846 18.2293 20.538 18.538C20.23 18.8467 19.8457 19.0007 19.385 19H4.615Z" fill="black"/>
                        </svg>
                       </div>
                      ): data.urlType == "mp4" ? [
                        <video onEnded={onEndedVideo(data)} width="100%" height="100px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} />
                      ]:<img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} />
                    }
                    {
                      currentHoveredBannerAds == "live" + index && (
                        <div className="banner-content-container fadeIn-2"/>  
                      )
                    }
                    
                    <div className="inner-controller d-flex">
                      {
                          currentHoveredBannerAds == "live" + index && (
                          <div className="d-flex fadeIn-2">
                            {
                              isGlobalAdsPage && (
                                <div onClick={e=>{handleEditContent(data); e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item m-r-8">
                                   <svg className="flex-item" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M19.1819 4.81833C18.6578 4.29436 17.9471 4 17.206 4C16.4649 4 15.7541 4.29436 15.23 4.81833L5.34722 14.7023C5.05902 14.9903 4.86017 15.3555 4.77459 15.7538L4.01279 19.3083C3.9927 19.4017 3.99632 19.4986 4.02333 19.5901C4.05034 19.6817 4.09986 19.7651 4.16739 19.8326C4.23491 19.9001 4.31828 19.9497 4.40987 19.9767C4.50147 20.0037 4.59837 20.0073 4.69172 19.9872L8.24641 19.2255C8.64477 19.1399 9.00993 18.941 9.29795 18.6528L19.1819 8.76942C19.7057 8.24539 20 7.5348 20 6.79387C20 6.05295 19.7057 5.34236 19.1819 4.81833ZM16.0387 5.62638C16.3512 5.33088 16.7666 5.16892 17.1967 5.17495C17.6267 5.18097 18.0375 5.35451 18.3415 5.65865C18.6456 5.96279 18.8191 6.37354 18.825 6.80357C18.8309 7.2336 18.6688 7.64897 18.3732 7.96137L17.8589 8.47569L15.5238 6.14126L16.0387 5.62638ZM14.7151 6.94931L17.0502 9.2843L8.49043 17.8454C8.35798 17.9778 8.19008 18.069 8.00695 18.1082L5.31465 18.6854L5.89186 15.9938C5.93105 15.8107 6.02235 15.6428 6.15474 15.5104L14.7151 6.94931Z" fill="black"/>
                                   </svg>
                                </div>
                              )
                            }
                            <div onClick={e=>{handleRemoveLiveContentPopup(data); e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item">
                              <svg className="flex-item" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.44202 11.6665C4.18068 11.6665 3.95824 11.5747 3.77468 11.3911C3.59113 11.2076 3.49935 10.9853 3.49935 10.7244V3.49979H2.91602V2.91645H5.24935V2.46729H8.74935V2.91645H11.0827V3.49979H10.4993V10.7244C10.4993 10.9927 10.4095 11.2169 10.2298 11.397C10.0502 11.577 9.82579 11.6668 9.55668 11.6665H4.44202ZM9.91602 3.49979H4.08268V10.7244C4.08268 10.829 4.11632 10.9149 4.1836 10.9822C4.25088 11.0495 4.33702 11.0831 4.44202 11.0831H9.55727C9.64671 11.0831 9.72896 11.0458 9.80402 10.9711C9.87907 10.8965 9.9164 10.814 9.91602 10.7238V3.49979ZM5.72068 9.91645H6.30402V4.66645H5.72068V9.91645ZM7.69468 9.91645H8.27802V4.66645H7.69468V9.91645Z" fill="#FF0000"/>
                              </svg>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  
                    {
                      currentHoveredBannerAds == "live" + index && (
                        <p className="flex-item color-white title fs-16 font-weight-300 fadeIn-2" style={{lineHeight:"22px",visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Content Name long, Content Name long"}</p>
                      )
                    }
                  </div> 
                )
              })
            }
          </div>

          <div className="d-flex space-between m-t-30">
            <div className="d-flex">
              <p className="flex-item font-weight-700 color-dark-blue m-r-12 fs-16">All Contents</p>
              <div className="number-highlighter d-flex">
                <p className="flex-item font-weight-600 fs-16" style={{color:"#107CB1"}}>{total.savedContent}</p>
              </div>
            </div>
            <div className="d-flex">
              <p className="flex-item font-weight-400 m-r-12 fs-16" style={{color:"#282828"}}>Publish Mode</p>
              <div onClick={() => toggleBannerAdsAssign()} className='flex-item d-flex active-inactive-button' style={{ background: !isBannerAdsAssign ? "rgba(255, 0, 85, 0.347)" : "" }}>
                <div className='active-inactive-ball flex-item' style={{ background: !isBannerAdsAssign ? "rgb(201, 0, 57)" : "", margin: !isBannerAdsAssign ? "0 0 0 0" : "" }} />
              </div>
            </div>
          </div>
          <div className="d-flex-wrap m-t-16 w-full">
            {
              mediaRecords.map((data, index) => {
                return(
                  <div onClick={handleOpenLiveAd.bind(this,data)} onMouseOver={()=>handleHoverCurrentBannerAds(index)} onMouseLeave={()=>handleLeaveCurrentBannerAds(index)} className="banner-content-container flex-item  m-r-20 m-b-20 cursor-pointer">
                    {
                        data.urlType == "mp4" ? (
                          <video onEnded={onEndedVideo(data)} width="100%" height="100px" style={{borderRadius:"12px"}} src={`${client.config.API_URL}${client.config.prefixAPI}/wp-mediarecord-player/${data.fileID}`} controls />
                        ):(
                          <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> 
                        )
                      }
                    {/* <img loading="lazy" className="flex-item" src={`${client.config.API_URL}/image/file/${data.fileID}/auto/auto/50`} /> */}
                    {
                      currentHoveredBannerAds == index && (
                        <div className="banner-content-container fadeIn-2"/>  
                      )
                    }
                    {
                      isBannerAdsAssign ? (
                        (publishedMediaRecords.findIndex(d=>d._id == data._id) == -1) && ( <div className="inner-controller d-flex">
                          <input onClick={handleSelectMediaRecord(data._id)} checked={selectedMediaRecordIDs.indexOf(data._id)!=-1} className="m-t-4 m-l-4" type="checkbox" style={{width:"18px", height:"18px"}} />
                        </div>)
                      ) : (
                        <div className="inner-controller d-flex">
                          {
                            currentHoveredBannerAds == index && (
                              <div className="d-flex fadeIn-2">
                                <div onClick={e=>{handleDeleteContentPopup(data);e.stopPropagation()}} className="controller-btn controller-btn-red d-flex flex-item">
                                  <svg className="flex-item" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.44202 11.6665C4.18068 11.6665 3.95824 11.5747 3.77468 11.3911C3.59113 11.2076 3.49935 10.9853 3.49935 10.7244V3.49979H2.91602V2.91645H5.24935V2.46729H8.74935V2.91645H11.0827V3.49979H10.4993V10.7244C10.4993 10.9927 10.4095 11.2169 10.2298 11.397C10.0502 11.577 9.82579 11.6668 9.55668 11.6665H4.44202ZM9.91602 3.49979H4.08268V10.7244C4.08268 10.829 4.11632 10.9149 4.1836 10.9822C4.25088 11.0495 4.33702 11.0831 4.44202 11.0831H9.55727C9.64671 11.0831 9.72896 11.0458 9.80402 10.9711C9.87907 10.8965 9.9164 10.814 9.91602 10.7238V3.49979ZM5.72068 9.91645H6.30402V4.66645H5.72068V9.91645ZM7.69468 9.91645H8.27802V4.66645H7.69468V9.91645Z" fill="#FF0000"/>
                                  </svg>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      )
                    }
                    {
                      currentHoveredBannerAds == index && (
                        <p className="flex-item color-white title fs-16 font-weight-300 fadeIn-2" style={{lineHeight:"22px",visibility:data.name?'visible':'hidden'}}>{data.name?data.name:"Content Name long, Content Name long"}</p>
                      )
                    }
                  </div> 
                )
              })
            }
          </div>
        </div>
        )
      }

      {
        (selectedMediaRecordIDs.length > 0) && ( 
          <div className="publish-content d-flex space-between">
            <div className="flex-item d-flex">
              <div className="selected-content d-flex flex-item m-r-8">
                <p className="flex-item margin-auto">{selectedMediaRecordIDs.length}</p>
              </div>
              <p className="flex-item">Ads Selected</p>
            </div>
            <div className="d-flex flex-item">
              <div onClick={handleCancelSelectedMediaRecord} className='global-button-container d-flex flex-item m-r-12'>
                <p className='flex-item'>Cancel</p>
              </div>
              {
                isGlobalAdsPage?(
                  <div onClick={isButtonLock?null:handleBranchSelect} className={`global-button-container ${isButtonLock ? "global-button-container-inactive":"global-button-container-active"} d-flex flex-item`}>
                    <p className='flex-item'>Select Branch & Proceed</p>
                  </div>
                ):(
                  <div onClick={isButtonLock?null:PubLishMediaRecord} className={`global-button-container ${isButtonLock ? "global-button-container-inactive":"global-button-container-active"} d-flex flex-item`}>
                    <p className='flex-item'>Review & Publish</p>
                  </div>
                )
              }
            </div>
          </div>
        )
      }

      {
        isOpenRemoveLiveContentPopup && <ManageConfirmationModal handleAction={handleRemoveLiveContentAction} title={"Are you sure you want to remove this content from kiosk's view?"} message="By performing this action, this content will no longer be displayed on any of the kiosks in the gym." buttonText={"Confirm"} handleClose={handleRemoveLiveContentPopup} isButtonLock={isButtonLock} />
      }

      {
        isCreateContentModalOpen && (
          <ManageBranchContent isEditOperationActive={isEditOperationActive.current} mediaRecord={selectedMediaRecord} selectedContentCount={selectedMediaRecordIDs.length} handleBranchIDs={handleBranchIDs} publishMediarecord={PubLishMediaRecord} isUpdateToPublishRecord={isUpdateToPublishRecord.current} isGlobalAds={isGlobalAdsPage} toggleCreateContent={toggleCreateContentModal} branch={branch} currentAdsType={currentAdsType} />
        )
      }

      {
        isOpenDeleteMediaRecordPopup && <ManageConfirmationModal handleAction={handleDeleteContentAction} title={"Are you sure you want to delete this content?"} message="By proceeding with this action, the content will be deleted and will no longer appear on any kiosks in the gym." buttonText={"Delete"} handleClose={handleDeleteContentPopup} isButtonLock={isButtonLock} />
      }

      {
        (isLiveAdsPreviewModalOpen && selectedMediaRecord) && (
          <LiveAdsPreview mediaRecord={selectedMediaRecord} adsType={selectedMediaRecord.isMainScreenBanner?"horizontal":"vertical"} close={handleCloseLiveAd.bind(this)}/>
        )
      }

    </Dashboard>
  )
}

export default KioskContent